import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation } from "@tanstack/react-query";

export interface CreateDevicePaymentCustomerPortalSessionParams {
  deviceId: string;
  returnUrl: string;
}

export interface CustomerPortalSessionResponse {
  url: string;
}

export function useCreateDevicePaymentCustomerPortalSessionMutation() {
  const mutation = useMutation({
    mutationFn: async (params: CreateDevicePaymentCustomerPortalSessionParams) => {
      const response = await OCGatewayClient.request('createDevicePaymentCustomerPortalSession', {
        deviceId: params.deviceId,
        returnUrl: params.returnUrl
      });

      return response as CustomerPortalSessionResponse;
    }
  });

  return mutation;
}